import { buildPermission } from "common/utils/auth";
import { Button, Paper, Typography } from "@mui/material";
import { changeArchetype, ImplementViewModel } from "../ImplementViewModel";
import { classes } from "common/theme/theme";
import { EditEquipmentButton } from "../../../EditEquipmentButton";
import { ImplementArchetype } from "protos/atk/autotractor";
import {
  PermissionAction,
  PermissionDomain,
  PermissionResource,
} from "protos/portal/auth";
import { useAuthorizationRequired } from "portal/components/auth/WithAuthorizationRequired";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import CheckIcon from "@mui/icons-material/Check";
import React, { FC } from "react";

interface ImplementArchetypeChooserProps {
  archetype: ImplementArchetype;
  disabled?: boolean;
}
export const ImplementArchetypeChooser: FC<ImplementArchetypeChooserProps> = ({
  archetype,
  disabled,
}) => {
  const { t } = useTranslation();
  const formikProps = useFormikContext<ImplementViewModel>();

  const isSelected = formikProps.values.archetype?.id === archetype.id;
  const canEditArchetypes = useAuthorizationRequired(
    buildPermission(
      PermissionAction.update,
      PermissionResource.atk_equipment,
      PermissionDomain.all
    )
  );
  return (
    <Paper
      className={classes(
        "w-96 flex flex-col gap-4 p-4 rounded-xl h-72",
        isSelected && "border-4 border-carbon-orange border-solid" // would love to use primary, but that's blue lol
      )}
      variant="outlined"
      data-testid={`archetype-${archetype.id}`}
    >
      <div className="flex flex-col">
        <div className="flex gap-2">
          <Typography variant="h6">{archetype.make}</Typography>
          <Typography variant="h6">{archetype.model}</Typography>
          <div className="flex ml-auto">
            {canEditArchetypes && (
              <EditEquipmentButton
                variant="icon"
                type="implement-archetype"
                equipmentId={archetype.id}
              />
            )}
            {isSelected && (
              <CheckIcon className="flex my-auto" color="primary" />
            )}
          </div>
        </div>
        <Typography color={"InactiveCaptionText"}>
          {archetype.series}
        </Typography>
      </div>
      <div className="flex flex-col gap-2"></div>
      <Button
        className="mt-auto"
        variant="contained"
        onClick={() => changeArchetype(formikProps, archetype)}
        disabled={isSelected || disabled}
      >
        {t("utils.actions.selectShort")}
      </Button>
    </Paper>
  );
};
